import React from 'react';
import CompliancePage from '../components/CompliancePage';
import { COMPLIANCE_PAGES } from '../config';

const RefundPolicyPage = () => {
  return <CompliancePage pageData={COMPLIANCE_PAGES.refundPolicy} />;
};

export default RefundPolicyPage;
